(function() {
    'use strict';

    angular
        .module('atheer.profiler', [
            'digestHud'
        ]);
})();
